module.exports = __webpack_public_path__ + "static/img/6.e48677d8.jpg";